import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, InputNumber, Radio, Row, Select, Tabs, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useLoaderData, useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import usepaymentAPI from '../apis/paymentAPI';
import EventEmitter from '../utils/eventEmitter';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { RxUpdate } from 'react-icons/rx';
import { LiaPercentSolid } from "react-icons/lia";
import usePaymentAPI from '../apis/paymentAPI';
import dayjs from 'dayjs';
import SmartButton from '../../globalComponents/SmartButton';
import { TiDocumentText } from "react-icons/ti";



const PaymentChanges = () => {
  const { payment, contacts, accounts, journals } = useLoaderData();
  payment['date'] = payment.date ? dayjs(payment['date'], 'YYYY-MM-DD') : '';
  const [form] = Form.useForm();
  const { save, update } = usePaymentAPI();
  const { success, error } = useOutletContext();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [paymentMethod, setPaymentMethod] = useState(payment.payment_methods ? payment.payment_methods : []);


  const onChangeJournal = (value, option) => {
    if (form.getFieldValue('type') === 'send') {
      form.setFieldValue('method', 'manual');
      setPaymentMethod(option.out);
    }else if (form.getFieldValue('type') === 'receive') {
      form.setFieldValue('method', 'manual');
      setPaymentMethod(option.in);
    }
  }

  const handleSave = () => {
    let data = form.getFieldsValue();
    data['is_customer'] = state.is_customer;
    data['date'] = new Date(data.date).toLocaleDateString();
    save(data, success, error);
    console.log(data);
  }

  const handleUpdate = () => {
    let data = form.getFieldsValue();
    update(payment.number, data, success);
  }

  useEffect(() => {
    EventEmitter.subscribe('payment_response', data => {
      // navigate('/accounting/payments/' + data, { state: {...state}});
    });
    return () => EventEmitter.unsubscribe('payment_response');
  }, [])


  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className=''>
        <div className='flex'>
          <h3 className='font-semibold'>
            <Link to={`/accounting/${state.is_customer ? 'customer': 'vendor'}/payments`} state={{...state}} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Payments</Link> / {params.action}
          </h3>
          <Tooltip title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={payment.number ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {payment.number && <Button htmlType='button' icon={<RxUpdate />} onClick={handleUpdate}>{'UPDATE'}</Button>}
      </div>
      <div className='mt-5 bg-white shadow'>
        {payment.journal_entry_id &&
          <Flex justify='flex-end' className='border-b m-0'>
            <SmartButton className='border-s-2' icon={<TiDocumentText size={'1.4rem'}/>} number={'Journal'} text={'Entry'} to={'/accounting/journal-entries/'+payment.number.replaceAll('/', '-')}/>
          </Flex>
        }
        <Form
          className='shadow p-3'
          form={form}
          labelAlign='left'
          labelCol={{md: {span: 8}}}
          initialValues={payment.number ? {...payment, amount: (payment?.amount?.$numberDecimal * 1).toFixed(2)} : { partner_type: state.is_customer ? 'receive' : 'send' }}
          autoComplete="off"
          variant='borderless'
        >
          <Form.Item name="partner_type" className='font-semibold mb-2' required >
            <Radio.Group disabled>
              <Radio value={'vendor'} className='font-normal'>Send</Radio>
              <Radio value={'customer'} className='font-normal'>Receive</Radio>
            </Radio.Group>
          </Form.Item>
          <Row>
            <Col md={{ span: 11 }}>
              <Form.Item label='Contact' name="contact_id" className='font-semibold mb-2' required >
              <Select options={contacts.map(contact => ({value: contact._id, label: contact.name}))} />
              </Form.Item>
              <Form.Item label='Amount' name="amount" className='font-semibold mb-2' required >
                <InputNumber className='w-full'/>
              </Form.Item>
              <Form.Item label='Date' name="date" className='font-semibold mb-2' required >
                <DatePicker className='font-normal w-full' />
              </Form.Item>
              <Form.Item label='Memo' name="memo" className='font-semibold mb-2' required >
                <Input className='input-outline-none font-normal' />
              </Form.Item>
            </Col>
            <Col md={{ span: 11, offset: 1 }}>
              <Form.Item label="Journal" name="journal_id" className='font-semibold mb-2' required >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name, out: journal.out_payment_method, in: journal.in_payment_method}))} onChange={onChangeJournal} className='font-normal'/>
              </Form.Item>
              <Form.Item label='Payment Method' name={'payment_method'} className='font-semibold mb-2' required >
                <Select options={paymentMethod.map(method => ({value: method.method, label: method.name}))} className='font-normal' />
              </Form.Item>
              <Form.Item label='Bank Account' name={'bank_account'} className='font-semibold mb-2' required >
                <Select options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='font-normal'/>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default PaymentChanges;